(() => {
  const site = document.querySelector('[data-ama-site]');
  if (!site) return;
  const menu = site.querySelector('[data-menu]');
  const nav = site.querySelector('[data-nav]');
  const header = site.querySelector('[data-header]');

  const closeMenu = () => { menu?.setAttribute('aria-expanded', 'false'); nav?.classList.remove('is-open'); document.body.classList.remove('ama-nav-open'); };
  menu?.addEventListener('click', () => { const open = menu.getAttribute('aria-expanded') !== 'true'; menu.setAttribute('aria-expanded', String(open)); nav.classList.toggle('is-open', open); document.body.classList.toggle('ama-nav-open', open); });
  nav?.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });

  const onScroll = () => header?.classList.toggle('is-scrolled', window.scrollY > 24);
  onScroll(); window.addEventListener('scroll', onScroll, { passive: true });

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) site.querySelectorAll('.ama-reveal').forEach(el => el.classList.add('is-visible'));
  else {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: .12, rootMargin: '0px 0px -45px' });
    site.querySelectorAll('.ama-reveal').forEach(el => observer.observe(el));
  }

  site.querySelectorAll('.ama-steps button').forEach(button => button.addEventListener('click', () => {
    const item = button.closest('li'); const panel = item.querySelector('div'); const open = button.getAttribute('aria-expanded') === 'true';
    site.querySelectorAll('.ama-steps button').forEach(other => { other.setAttribute('aria-expanded', 'false'); other.closest('li').querySelector('div').hidden = true; });
    if (!open) { button.setAttribute('aria-expanded', 'true'); panel.hidden = false; }
  }));

  site.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
    const target = document.querySelector(link.getAttribute('href')); if (!target) return; event.preventDefault(); target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
  }));
})();
